// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"541":"45a1ab81","591":"c19c40c6","671":"e2a48703","686":"225441ba","761":"45fb30e1"}[chunkId] + ".chunk.css";
};